import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { SearchClientService } from '@mode/algolia/domain';
import { AlgoliaSuggestionService } from '~/plugins/ace/completion-providers/algolia-suggestion.service';
import { DataIndexSuggestionService } from '~/plugins/ace/completion-providers/data-index-suggestion.service';
import { FeatureFlag } from '@mode/shared/contract-common';
import { getInitialFlagValue } from '@mode/shared/util-js';

export const DowngradedSharedDataAccessAlgoliaModule = angular
  .module('downgraded-shared-data-access-algolia', [])
  .service('SearchClientService', downgradeInjectable(SearchClientService))
  .service(
    'SuggestionService',
    getInitialFlagValue(FeatureFlag.AlgoliaToOpenSearchAutocomplete)
      ? downgradeInjectable(DataIndexSuggestionService)
      : downgradeInjectable(AlgoliaSuggestionService)
  ).name;
